export default __webpack_public_path__ + "static/media/Number_3_selected_hsb.e4beb987.svg";